import styles from "./HeaderFree.module.scss";
import moai from "../../../../src/assets/images/dashboard_icons/moai.png";
import { EventsList } from "./EventsList";
import { useState, useEffect } from "react";
export default function HeaderFree() {
  const [event, setEvent] = useState(null);

  const nearestDate = () => {
    let today = new Date();
    let nextDay;
    let difference;
    let min = -999;
    let minName;
    let send = false;
    EventsList.map((item) => {
      nextDay = new Date(item.date);
      difference = Math.round(
        (today.getTime() - nextDay.getTime()) / (1000 * 3600 * 24)
      );
      if (difference < 0 && difference > min) {
        min = difference;
        minName = item.name;
        send = true;
      }
    });
    send && setEvent({ days: Math.abs(min), name: minName });
  };
  useEffect(() => {
    nearestDate();
  }, []);
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <span>Dni do najbliższego święta:</span>
          <span className={styles.value}>
            {event !== null ? event.days : "0"}
          </span>
          <span className={styles.add}>
            {event !== null ? event.name : "Brak danych"}
          </span>
        </div>
        <img src={moai} />
      </div>
    </>
  );
}
